import React, { useState, useEffect } from 'react';
import { api } from '../api';
import '../css/reviews.css';
import FadeInSection from '../components/FadeInSection';

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({ name: '', role: '', rating: 0, text: '' });
  const [sent, setSent] = useState(false);

  useEffect(() => {
    api.get('/reviews').then(d => Array.isArray(d) && setReviews(d)).catch(() => {});
  }, []);

  const submit = async e => {
    e.preventDefault();
    if (!form.rating) return alert('Please select a rating');
    const res = await api.post('/reviews', form);
    if (res.success) setSent(true);
  };

  const displayReviews = reviews.length > 0 ? reviews : [
    { id: '1', name: 'Ahmed Karimi', role: 'CEO, TechStart Erbil', rating: 5, text: 'AMKO completely transformed our brand. Everything was perfect.' },
    { id: '2', name: 'Sara Rashid', role: 'Marketing Director', rating: 5, text: 'The event they managed for our product launch was spectacular.' },
    { id: '3', name: 'Mohammad Hassan', role: 'Owner, Kurdistan Food Co.', rating: 5, text: 'Our social media grew from 2K to 40K followers in 6 months.' },
  ];

  return (
    <div className="reviews-page">
      <FadeInSection direction="up">
      <section className="reviews-hero">
        <div className="container">
          <span className="section-tag">Client Feedback</span>
          <h1>What Clients Say</h1>
          <div className="rating-row">
            <span className="rating-num">4.9</span>
            <div><div className="stars">★★★★★</div><div className="rating-count">Based on 48 reviews</div></div>
          </div>
        </div>
      </section>
      </FadeInSection>

      <FadeInSection direction="right">
      <section className="section section-white">
        <div className="container">
          <div className="reviews-grid">
            {displayReviews.map(r => (
              <div key={r.id} className="review-card">
                <div className="stars">{'★'.repeat(r.rating)}</div>
                <p className="review-text">"{r.text}"</p>
                <div className="review-author">
                  <div className="review-avatar">{r.name.split(' ').map(w => w[0]).join('')}</div>
                  <div><div className="review-name">{r.name}</div><div className="review-role">{r.role}</div></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      </FadeInSection>

      <FadeInSection direction="up" delay={100}>
      <section className="section section-bg">
        <div className="container container-sm">
          <h2>Leave a Review</h2>
          <p className="section-sub">Reviews are approved before publishing.</p>
          {sent ? (
            <div className="sent-box">
              <div>🙏</div>
              <h3>Thank You!</h3>
              <p>Your review has been submitted for approval.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="form">
              <div className="form-row">
                <input placeholder="Your Name *" required value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
                <input placeholder="Role / Company" value={form.role} onChange={e => setForm(p => ({ ...p, role: e.target.value }))} />
              </div>
              <div className="rating-select">
                <label>Rating *</label>
                <div className="stars-input">
                  {[1,2,3,4,5].map(n => (
                    <button type="button" key={n} className={`star-btn ${n <= form.rating ? 'active' : ''}`} onClick={() => setForm(p => ({ ...p, rating: n }))}>★</button>
                  ))}
                </div>
              </div>
              <textarea rows={4} placeholder="Share your experience... *" required value={form.text} onChange={e => setForm(p => ({ ...p, text: e.target.value }))} />
              <button type="submit" className="btn-primary">Submit Review</button>
            </form>
          )}
        </div>
      </section>
      </FadeInSection>
    </div>
  );
}
